import { Component, OnInit, ViewChild, AfterViewInit } from '@angular/core';
import { ElementRef } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Location } from "@angular/common";

@Component({
  selector: 'app-captura',
  templateUrl: './captura.component.html',
  styleUrls: ['./captura.component.scss']
})
export class CapturaComponent implements OnInit {
  public detalhe: Array<any> = [];
  public codigo: String = '';

  public autor: string = '';
  public data_atualizacao: string = '';
  public id: string = '';
  public orgao: string = '';
  public texto: string = '';
  public titulo: string = '';
  public pdf: string = '';
  public tipo: string = '';

  public imageUrl: string = '';
/*
  public videoElement: HTMLVideoElement | undefined;
  public canvasElement: HTMLCanvasElement | undefined;
  public imageUrl: string | undefined;
*/
  public stream: MediaStream | undefined;

  
  @ViewChild('video', {static: true}) videoElement!: ElementRef<HTMLVideoElement>;
  @ViewChild('canvas', {static: true}) canvasElement!: ElementRef<HTMLCanvasElement>;
  @ViewChild('drawCanvas', { static: false }) canvas!: ElementRef<HTMLCanvasElement>;


  @ViewChild('draw') drawElement: ElementRef;
  @ViewChild('capture') captureButton: ElementRef;
  @ViewChild('add-bar') addBarButton: ElementRef;
  @ViewChild('clear') clearButton: ElementRef;
  @ViewChild('camera-select') cameraSelect: ElementRef;

  constructor(
    //private BuscaJsonService: BuscaJsonService,
    private route: ActivatedRoute,
    private location: Location
  ) { }

  ngOnInit(): void {
    this.startWebCam();
  }

  ngAfterViewInit(): void {
    this.canvas.nativeElement.addEventListener('click', (event: MouseEvent) => {
      this.addStripe(event.offsetX, event.offsetY);
    });
  }

  private addStripe(x: number, y: number): void {
    const ctx = this.canvas.nativeElement.getContext('2d');
    if (!ctx) return;

    ctx.fillStyle = 'black'; // Cor da tarja
    const stripeWidth = 150;
    const stripeHeight = 20;

    ctx.fillRect(x, y, stripeWidth, stripeHeight);
  }

  public clearStripes(): void {
    const ctx = this.canvas.nativeElement.getContext('2d');
    if (!ctx) return;

    ctx.clearRect(0, 0, this.canvas.nativeElement.width, this.canvas.nativeElement.height);
  }

  private startWebCam(): void {
    navigator.mediaDevices.getUserMedia({ video: true })
      .then((stream) => {
        const video = this.videoElement.nativeElement;
        video.srcObject = stream;
        video.play();
      })
      .catch((error) => {
        console.error('Error accessing the webcam: ', error);
      });

  }

  public captureImage(): void {
    const video = this.videoElement.nativeElement;
    const canvas = this.canvasElement.nativeElement;
    const drawCanvas = this.canvas.nativeElement;

    canvas.width = video.videoWidth;
    canvas.height = video.videoHeight;
    drawCanvas.width = video.videoWidth;
    drawCanvas.height = video.videoHeight;

    const context = canvas.getContext('2d');
    if(context){
      context.drawImage(video, 0, 0, canvas.width, canvas.height);
      this.imageUrl = canvas.toDataURL('image/png');

    }

  }
}
